<template>
    <m-layout>
      <div fill-height class="fill-height" style="max-width:100%; position:relative">
        <v-card-title class="m-page__title">
          <span class="headline">Clients</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title>
        <m-confirm ref="confirm"></m-confirm>
        <m-client-form :form="formClient" :user="selectedItem" :dialog="dialog_client" @save="saveClient" @close="closeClient"></m-client-form>
        <m-client-edit-form :form="formClient" :user="selectedItem" :dialog="dialog_client_edit" @update="updateClient" @close="closeClient"></m-client-edit-form>


        <v-card style="max-width:100%; position:relative">

          <v-card-title>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog_client = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :options.sync="options"
              :sort-by="['id']"
              :sort-desc="[true]"
              :footer-props="{
                'items-per-page-options': [30, 40, {text:'All', value:-1}]
              }"
              dense
            >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id" :class="{'error-item' :  inValidItem(item)}">

                <td >{{ item.id }}</td>
                <td >{{ item.firstname }}</td>
                <td >{{ item.lastname }}</td>
                <td >{{ item.address }}</td>
                <td >{{ item.zip }}</td>
                <td >{{ item.city }}</td>
                <td >{{ item.birthday }}</td>
                <td >{{ item.tel }}</td>
                <td >{{ item.mobile }}</td>
                <td >{{ item.role }}</td>
                <td >{{ item.email }}</td>
                <td >{{ item.client_from }}</td>
                <td>
                  <div style="display: flex">
                  <v-btn icon class="mx-0" @click="editItem(item)">
                    <v-icon color="primary">edit</v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0" @click="deleteItem(item)">
                    <v-icon color="primary">delete</v-icon>
                  </v-btn>
                  </div>
                </td>
              </tr>
              </tbody>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>


      </div>
    </m-layout>
</template>

<script>
  import Confirm from '../../components/confirm.vue'
  import ClientForm from '../../components/client/form.vue'
  import ClientEditForm from '@/components/client/edit.vue'

  export default {
    components: {
      'm-confirm': Confirm,
      'm-client-form': ClientForm,
      'm-client-edit-form': ClientEditForm
    },
    data () {
      return {
        formClient: {},
        dateFormatted: null,
        dialog_client: false,
        dialog_client_edit: false,
        search: '',
        options: {},
        selectedItem: {},
        headers: [
          {
            text: 'ID',
            align: 'left',
            value: 'id'
          },
          { text: 'Firstname', value: 'firstname' },
          { text: 'Lastname', value: 'lastname' },
          { text: 'Address', value: 'address' },
          { text: 'Zip', value: 'zip' },
          { text: 'City', value: 'city' },
          { text: 'Birthday', value: 'birthday' },
          { text: 'Tel', value: 'tel' },
          { text: 'Mobile', value: 'mobile' },
          { text: 'Role', value: 'role' },
          { text: 'Email', value: 'email' },
          { text: 'Client from', value: 'client_from' },
          { text: 'Action', value: 'action' }
        ],
        items: []
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      closeClient () {
        this.dialog_client = false;
        this.dialog_client_edit = false;
        this.resetClient();
        console.log('close');
      },
      resetClient () {
        this.formClient = {};
      },
      onRefresh () {
        this.getDataClient();
      },
      inValidItem (item) {
        return !item.fullAddress;
      },
      saveClient (data) {
        // var app = this;
        this.$http
        .post('api/client', data)
        .then(response => {
          console.log('response data', response.data);
          // app.items = response.data;
          this.closeClient();
          this.getDataClient();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      updateClient (data) {
        // var app = this;
        var id = this.selectedItem.id;
        this.$http
        .put('api/client/' + id, data)
        .then(response => {
          console.log('response data', response.data);
          // this.reset();
          this.getDataClient();
          this.closeClient();
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      editItem (item) {
        this.resetClient();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_client_edit = true;
        console.log('edit', this.selectedItem.id);
      },
      deleteItem (item) {
        this.$refs.confirm.open('Delete', item.firstname + ' ' + item.lastname + ' ?').then((confirm) => {
          if (confirm) {
            this.$http
            .delete('api/client/' + item.id)
            .then(response => {
              console.log('user deleted', response.data);
              this.getDataClient();
            })
            .catch(function (error) {
              console.log('catch:', error);
            });
          }
        });
      },
      getDataClient () {
        var app = this;
        this.$http
        .get('api/client')
        .then(response => {
          console.log('data', response.data);
          app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getDataById (id) {
        var app = this;
        return new Promise((resolve, reject) => {
          this.$http
          .get('api/client/' + id)
          .then(response => {
            console.log('client getDataById:', response.data);
            app.items = response.data;
            resolve(app.items);
          })
          .catch(function (error) {
            reject(error);
          });
        });
      },
      isDirectLink (item) {
        item = item || this.$route.params.item || {}
        if (item.id && item.route === this.$route.name) {
          this.getDataById(item.id).then((items) => {
            this.editItem(items[0]);
          });
          this.$route.params.item = null;
        }
      }
    },
    created () {
      this.getDataClient();
      this.$bus.$on('search:show', this.isDirectLink);
    },
    mounted () {
      this.isDirectLink();
    },
    beforeDestroy () {
      this.$bus.$off('search:show', this.isDirectLink);
    }
  }
</script>

<style lang="scss">
.error {
  text-transform: none;
  color: grey;

  &-item {
    color:rgba(248, 1, 1, 1) !important;
  }
}
</style>









